export enum ShopType {
  RETAIL= 'RETAIL',
  GAMBLING = 'GAMBLING',
  HEALTHCARE = 'HEALTHCARE',
  TELCO = 'TELCO',
  TRAVEL = 'TRAVEL',
  OTHER = 'OTHER',
}
